// extracted by css-extract-rspack-plugin
export default {"root":"root-3Rv9y","wrapper":"wrapper-1SEMA","interactive":"interactive-3SZdR","selection":"selection-J1M76"};